import React, { useState, useEffect, useMemo } from 'react';
import { 
  LayoutDashboard, Users, Package, FileText, Settings as SettingsIcon, Plus, Search, Trash2, 
  Save, X, Mail, Phone, DollarSign, ChevronLeft, Filter, Upload, Edit, Download, Database, 
  RefreshCw, Globe, User, CheckCircle, Send, ArrowLeft, ArrowRight, BarChart3, LogOut, Shield, 
  Cloud, FileSpreadsheet, Loader, Copy, Sun, Moon, MessageCircle, FileX, Bell, Clock, 
  AlertCircle, Check, MapPin, Hash, UserCheck, Smartphone, Tag
} from 'lucide-react';
import { THEMES, HOSTINGER_API_URL, CATEGORY_SORT_ORDER, DEFAULT_CATEGORIES, DEFAULT_TERMS, COMPANY_INFO, STATUS_OPTIONS } from '../config/constants';
import { apiCall } from '../services/api';

const Modal = ({ isOpen, onClose, title, children, theme, className = "max-width-lg" }) => {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-900/40 backdrop-blur-sm p-4 animate-in fade-in duration-300">
      <div className={`${theme === 'dark' ? 'bg-slate-900 border border-slate-700' : 'bg-white/70 backdrop-blur-2xl border border-white/60'} rounded-[2rem] shadow-2xl w-full ${className} flex flex-col max-h-[90vh] animate-in zoom-in-95 duration-300 overflow-hidden`}>
        <div className={`p-6 border-b ${theme === 'dark' ? 'border-slate-800' : 'border-white/40'} flex justify-between items-center bg-white/20`}>
          <h3 className={`font-bold text-xl ${THEMES[theme].heading}`}>{title}</h3>
          <button onClick={onClose} className={`${theme === 'dark' ? 'text-slate-400 hover:text-white' : 'text-slate-400 hover:text-slate-600 hover:bg-black/5'} p-2 rounded-full transition-colors`}><X size={20} /></button>
        </div>
        <div className="p-8 overflow-y-auto custom-scrollbar flex-1">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
